import keyMirror from 'keymirror'

export default keyMirror({
  GET_KEY_SETTINGS_REQUEST: null,
  GET_KEY_SETTINGS_SUCCESS: null,
  GET_KEY_SETTINGS_FAILED: null,

  UPDATE_KEY_SETTINGS_REQUEST: null,
  UPDATE_KEY_SETTINGS_SUCCESS: null,
  UPDATE_KEY_SETTINGS_FAILED: null,

  UPLOAD_FACTORY_PUBLIC_KEY_REQUEST: null,
  UPLOAD_FACTORY_PUBLIC_KEY_SUCCESS: null,
  UPLOAD_FACTORY_PUBLIC_KEY_ERROR: null,

  DELETE_FACTORY_PUBLIC_KEY_REQUEST: null,
  DELETE_FACTORY_PUBLIC_KEY_SUCCESS: null,
  DELETE_FACTORY_PUBLIC_KEY_ERROR: null,

  GET_KEY_SETTINGS_COMMENTS_REQUEST: null,
  GET_KEY_SETTINGS_COMMENTS_SUCCESS: null,
  GET_KEY_SETTINGS_COMMENTS_ERROR: null,

  ADD_KEY_SETTINGS_COMMENT_REQUEST: null,
  ADD_KEY_SETTINGS_COMMENT_SUCCESS: null,
  ADD_KEY_SETTINGS_COMMENT_ERROR: null,

  UPDATE_KEY_SETTINGS_COMMENT_REQUEST: null,
  UPDATE_KEY_SETTINGS_COMMENT_SUCCESS: null,
  UPDATE_KEY_SETTINGS_COMMENT_ERROR: null,

  DELETE_KEY_SETTINGS_COMMENT_REQUEST: null,
  DELETE_KEY_SETTINGS_COMMENT_SUCCESS: null,
  DELETE_KEY_SETTINGS_COMMENT_ERROR: null
})
